import { stringify } from 'querystring';
import { Service } from 'vue-di-container';

@Service()
export default class ValidationService {
    public readonly phoneCodePhoneNumber: string = '05';
    public readonly phoneCodeFixedPhone: string = '01';
    public readonly emailPattern: RegExp = /\b^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$\b/;

    public isValidEmail(email: string) {
        return this.emailPattern.test(email);
    }
    public validateLength(max: number, text: any, evt?: KeyboardEvent): boolean {
        if (evt !== undefined) {
            const pattern = /^[0-9]+$/;
            if ((text && text.length >= max) || !pattern.test(evt.key)) {
                evt.preventDefault();
                return false;
            } else {
                return true;
            }
        } else {
            return text && text.length <= max ? true : false;
        }
    }
    public validateLengthString(max: number, text: any, evt?: KeyboardEvent): boolean {
        if (evt !== undefined) {
            if (text && text.length >= max) {
                evt.preventDefault();
                return false;
            } else {
                return true;
            }
        } else {
            return text && text.length <= max ? true : false;
        }
    }
    public isValidNumber(phoneNumber: string, prefixNumber: string, length: number): boolean {
        return (phoneNumber.length === length && phoneNumber.startsWith(prefixNumber));
    }
    public isArabic(text: string) {
        const pattern = /^[\u0621-\u064A\u0660-\u0669 ]+$/;
        return pattern.test(text);
    }
    public calculateRemainingCharactersCount(count: number, value: string) {
        return count - value.length;
    }
    public maxLength(max: number, that: any, evt: Event) {
        if (that.length >= max) {
            evt.preventDefault();
            return false;
        }
    }
    public isNumber(num: string) {
        return /^[0-9]$/.test(num);
    }
    public isDate(num: string) {
        return /^[0-9-]$/.test(num);
    }
    public isNumeric(text: any): boolean {
        const pattern = /^[0-9]+$/;
        return pattern.test(text);
    }

    public isValidVatNumber(vatNumber: string): boolean {
        if (!vatNumber) {
            return false;
        }
        const value = vatNumber.trim();
        return value.length === 15 && value.charAt(0) === '3' && value.charAt(14) === '3' && this.isNumeric(value);
    }

    /** Charity Enterprise Unified Number: exactly 10 digits starting with 7. */
    public isValidCharityEnterpriseNumber(enterpriseUnifiedNumber: string): boolean {
        if (!enterpriseUnifiedNumber) {
            return false;
        }
        const value = enterpriseUnifiedNumber.trim();
        return value.length === 10 && value.startsWith('7') && this.isNumeric(value);
    }

    public calcMaxDate() {
        const date = new Date();
        date.setTime(date.getTime());
        return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    }
}
